import { AlertCircle, AlertTriangle, Info } from 'lucide-react';
import type { Issue } from '../../engine/core/types';

const severityIcon = {
  critical: AlertCircle,
  high: AlertTriangle,
  medium: AlertTriangle,
  low: Info,
  info: Info,
};

export function IssueList({ issues }: { issues: Issue[] }): React.JSX.Element {
  return (
    <section className="analysis-panel issues-panel" aria-labelledby="issues-title">
      <div className="panel-heading"><h2 id="issues-title">Issues detected ({issues.length})</h2></div>
      {issues.length === 0 ? (
        <div className="panel-empty"><strong>No structural issues detected</strong><span>This result covers the checks implemented by this MendByte engine release.</span></div>
      ) : (
        <div className="issue-table" role="group" aria-label="Detected file issues">
          <div className="issue-table__header"><span>Severity</span><span>Issue</span><span>Location</span><span>Evidence</span></div>
          {issues.map((issue) => {
            const Icon = severityIcon[issue.severity];
            return (
              <details className="issue-row" key={issue.id}>
                <summary>
                  <span className={`severity severity--${issue.severity}`}><Icon />{issue.severity}</span>
                  <strong>{issue.title}</strong>
                  <code>{issue.component}</code>
                  <span>{issue.evidence}</span>
                </summary>
                <div className="issue-row__detail"><p>{issue.detail}</p><p><strong>Repair:</strong> {issue.repairable ? `${issue.rule?.id} ${issue.rule?.version} · ${issue.confidence} confidence` : 'No safe automated rule available.'}</p></div>
              </details>
            );
          })}
        </div>
      )}
    </section>
  );
}
